import React, { useState, useEffect } from "react";

import { Box, Card, Grid, Typography, Button, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';

import GlobalConfig from "../../../config/date/GlobalConfig";
import * as XLSX from "xlsx";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const FGStockReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [partyList, setPartyList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };


    const getFGStockReport = () => {
        let parameters = {
            p_companyid: 1,

        };

        callApi(API_ENDPOINTS.PRODUCTION_GET_FG_STOCK_REPORT, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setPartyList(data);

            })
            .catch(error => {
                // // Update state with error message        
                // setReelWeightementSeverityvalue('error');
                // setReelWeightementMessageValue(error.message);
                // setReelWeightementAlertTitleValue('Error');
                // setReelWeightementMsgOpen(true);
            });

    };

    useEffect(() => {
        if (partyList) {
            getFGStockReport();
        }

    }, [partyList]);

    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });
    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

     // Table headers
  const headers = [
    "SALES ORDER",
    "ITEM NO",
    "BUNDLE/ LOTNO.",
    "NET WEIGHT(KG)",
    "GROSS WEIGHT",
    "TARE WEIGHT",
    "NO.OF.REAMS/ REELS",
    "INTACT BUNDLES",
    "LOOSE",
    "TOTAL NO.OF.BUNDLE / REEL",
    "REAM WT.",  
    "WIDTH",
    "LENGTH",
    "PRODUCT CODE",
    "GSM"
  ];

  const handleExportToExcel = () => {
    // Prepare the data with headers
    const formattedData = partyList.map(row => ({
      "SALES ORDER": row.indent_no,
      "ITEM NO": row.line_no,
      "BUNDLE/ LOTNO.": row.cr_number,
      "NET WEIGHT(KG)": row.netweight,
      "GROSS WEIGHT": row.grossweight,
      "TARE WEIGHT": row.tareweight,
      "NO.OF.REAMS/ REELS": row.noofreams_reels,
      "INTACT BUNDLES": row.intactbundles,
      "LOOSE": row.loose,
      "TOTAL NO.OF.BUNDLE / REEL": row.noofbundles_reel,
      "REAM WT.": row.reamwt,
      "WIDTH": row.width,
      "LENGTH": row.length,
      "PRODUCT CODE": row.productcode,
      "GSM": row.gsm,
    }));

    // Create a new worksheet with headers
    const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FG Stock");

    // Export the file
    XLSX.writeFile(workbook, "FG Stock Details.xlsx");
  };

    const HandleClose = () => {
        handleExportToExcel();
    }

    return (
        <>
            <Box style={{ backgroundColor: "transparent" }}>
                <Box style={{ backgroundColor: "#0277bd" }} flexDirection={'row'} p={'5px'}>
                    <ReportsHeader title={'Finished Goods Stock Report'} subtitle="" callback={handleBackWinderMachineEntry} />
                </Box>
                <CardContent sx={{ border: "1px solid #3d3d3d" }}>  
                    <Box display="flex" flexDirection={'column'}>

                        <Box m='0px' display="flex" justifyContent={'end'}>
                            {/* <Grid container spacing={1} justifyContent="start" style={{ marginTop: '0px' }}>
                                <Grid item lg={1.5} xs={1.5} xl={1}>
                                    <Typography mt={1} ml={0} style={{ fontSize: '14px' }}> Filter By : Period </Typography>
                                </Grid>
                                <Grid item lg={2} xs={4} xl={1.5}>
                                    <FormControl fullWidth size="small">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                // label="From date"
                                                style={{ marginLeft: '10px' }}
                                                id="FromDate"
                                                value={dayjs(FromDate)}
                                                onChange={(date) => handleDateChange2(date)}
                                                slotProps={{ textField: { size: 'small', } }}
                                                renderInput={(props) => <TextField {...props} />}
                                                autoFocus
                                                format="DD-MMM-YYYY" // Use the appropriate format string
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>

                                <Grid item lg={2} xs={4} xl={1.5}>
                                    <FormControl fullWidth size="small" >
                                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                            <DatePicker
                                                // label="To date"
                                                id="ToDate"
                                                value={dayjs(ToDate)}
                                                format="DD-MMM-YYYY"
                                                onChange={(date) => handleDateChange1(date)}
                                                slotProps={{ textField: { size: 'small', } }}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                            </Grid> */}

                            <Tooltip title="Download Report" onClick={HandleClose}>
                                <IconButton >
                                    <FileDownloadIcon style={{ color: "#1de9b6" }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box
                        gridColumn="span 9"
                        gridRow="span 2"
                        alignItems="center"
                        justifyContent="center"
                        // padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                border: "1px solid",
                                borderColor: `${colors.primary[400]} !important`,
                                padding: "2px",  // Further reduced padding
                            },
                            "& .MuiTableHead-root": {
                                borderBottom: "none",
                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                            // scroll bar
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '63vh', // Large devices (desktops)
                                xl: '80vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}
                    >
                        <TableContainer >
                            <Table stickyHeader size="small" sx={{ tableLayout: 'fixed' }}> 
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                      
                                        <TableCell sx={{width:'100px'}}>SALES ORDER</TableCell>
                                        <TableCell sx={{width:'100px'}}>ITEM NO</TableCell>
                                        <TableCell sx={{width:'100px'}}>CONC</TableCell>
                                        <TableCell sx={{width:'100px'}}>BUNDLE/ LOTNO.</TableCell>
                                        <TableCell sx={{width:'100px'}}>NET WEIGHT(KG)</TableCell>
                                        <TableCell sx={{width:'100px'}}>GROSS WEIGHT</TableCell>
                                        <TableCell sx={{width:'100px'}}>TARE WEIGHT</TableCell>
                                        <TableCell sx={{width:'130px'}}>NO.OF.REAMS/ REELS</TableCell>
                                        <TableCell sx={{width:'100px'}}>INTACT BUNDLES</TableCell>
                                        <TableCell sx={{width:'100px'}}>LOOSE</TableCell>
                                        <TableCell sx={{width:'160px'}}>TOTAL NO.OF.BUNDLE / REEL                                        </TableCell>
                                        <TableCell sx={{width:'100px'}}>REAM WT.</TableCell>
                                       
                                        <TableCell sx={{width:'80px'}}>WIDTH</TableCell>
                                        <TableCell sx={{width:'80px'}}>LENGTH</TableCell>
                                        <TableCell sx={{width:'100px'}}>PRODUCT CODE </TableCell>
                                        <TableCell sx={{width:'80px'}}>GSM </TableCell>
                                        <TableCell sx={{width:'80px'}}>PO </TableCell>
                                        <TableCell sx={{width:'100px'}}>PO ITEM NO </TableCell>
                                        <TableCell sx={{width:'100px'}}>BATCH NO </TableCell>
                                       
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id}>
                                        
                                            <TableCell>{row.indent_no}</TableCell>
                                            <TableCell>{row.line_no}</TableCell>                                     
                                            <TableCell>{row.indent_no}</TableCell>
                                            <TableCell>
                                              
                                                    {row.cr_number}
                                            
                                            </TableCell>
                                            <TableCell>{row.netweight}</TableCell>
                                            <TableCell>{row.grossweight}</TableCell>
                                            <TableCell>{row.tareweight}</TableCell>
                                            <TableCell>{row.noofreams_reels}</TableCell>
                                            <TableCell>{row.intactbundles}</TableCell>

                                            <TableCell>{row.loose}</TableCell>
                                            <TableCell>{row.noofbundles_reel}</TableCell>

                                            <TableCell>{row.reamwt}</TableCell>
                                            <TableCell>{row.width}</TableCell>
                                            <TableCell>{row.length}</TableCell>
                                            <TableCell>{row.productcode}</TableCell>
                                            <TableCell>{row.gsm}</TableCell>

                                            <TableCell>{row.po}</TableCell>
                                            <TableCell>{row.po_item_no}</TableCell>
                                            <TableCell>{row.batch_no}</TableCell>                                          
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </CardContent>

            </Box>

        </>
    )
};
export default FGStockReport;